<div class="add-container">
    <h1 class="add-title">Adaugă Document</h1>
    <div class="solicitare-card__upload mb-5">
        <div class="solicitare-card__upload-header">
            <p class="upload-text">Documente PDF</p>
            <button class="upload-btn" (click)="fileInput.click()" type="button" [disabled]="isUploading || isLoading">
                <mat-icon class="upload-icon me-2">cloud_upload</mat-icon>
                ÎNCARCĂ
            </button>
        </div>

        <!-- Progress bar pentru upload în progres -->
        <div *ngIf="isUploading" class="upload-progress-container">
            <mat-progress-bar mode="determinate" [value]="getTotalProgress()" class="upload-progress-bar">
            </mat-progress-bar>
            <span class="progress-text">{{getTotalProgress()}}%</span>
            <div class="upload-status-text">Se încarcă documentele...</div>
        </div>

        <!-- Lista fișierelor uploadate cu succes -->
        <div class="solicitare-card__upload-files" *ngIf="finalPayloads.length > 0 && !isUploading">
            <!-- <div class="uploaded-files-header">
                <h4>Documente încărcate cu succes:</h4>
            </div> -->
            <div class="solicitare-card__upload-file uploaded-file"
                *ngFor="let payload of finalPayloads; let i = index">
                <div class="file-details">
                    <span class="solicitare-card__upload-file-name">
                        {{ (payload.document_oficial.display_name.length > 30) ?
                        (payload.document_oficial.display_name | slice: 0:30) + '..' :
                        payload.document_oficial.display_name }}
                    </span>
                    <!-- <span class="chunk-info" *ngIf="payload.document_oficial.numar_chunks > 1">
                        ({{payload.document_oficial.numar_chunks}} chunk-uri)
                    </span> -->
                </div>
                <div>
                    <button class="solicitare-card__upload-file-delete" type="button"
                        matTooltip="Șterge documentul încarcat" (click)="removeUploadedFile(i)" [disabled]="isLoading">
                        <img class="btn-img" src="../../../assets/icons/delete.svg" alt="" />
                    </button>
                </div>
            </div>
        </div>

        <!-- Spinner pentru upload în progres -->
        <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px" *ngIf="isUploading"></mat-spinner>

        <input type="file" accept="application/pdf" id="upload-file-input-0" #fileInput name="fileInput"
            (change)="onFileSelected($event)" multiple style="display: none">
    </div>

    <!-- Butoanele pentru dialog -->
    <div class="row">
        <div class="col d-flex justify-content-between">
            <button class="buttons" type="button" mat-flat-button (click)="closeDialog()" [disabled]="isLoading">
                {{ helper.dialogConfig.buttonLabels.close }}
            </button>
            <button class="buttons" type="button" mat-flat-button color="primary" (click)="submitDocuments()"
                [disabled]="finalPayloads.length === 0 || isLoading">
                {{ helper.dialogConfig.buttonLabels.save }}
            </button>
        </div>
    </div>

    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>